/** Table row mappers for delegation invite / request property lists (prod column parity). */

import { formatDispositioned } from 'utils/dispositionedDisplay';
import { maskDemoField } from 'utils/demoMask';

export { formatDispositioned };

export function mapDelegationInviteTableRow(building, isDemo = false) {
  return [
    building.building_id,
    maskDemoField(isDemo, 'building-name', building.name || '-'),
    building.building_type || 'Undefined',
    maskDemoField(isDemo, 'phone', building.phone || '-'),
    maskDemoField(isDemo, 'address-street', building.billingStreet || '-'),
    maskDemoField(isDemo, 'email', building.email_address || '-'),
    building.total_of_units || 0,
    building.student_housing,
    formatDispositioned(building.dispositioned),
    maskDemoField(isDemo, 'landlord-name', building.landlord_name || '-'),
    building.building_id,
  ];
}

export function mapDelegationRequestTableRow(building, isDemo = false) {
  return [
    building.building_id,
    maskDemoField(isDemo, 'building-name', building.name || '-'),
    building.building_type || 'Undefined',
    maskDemoField(isDemo, 'phone', building.phone || '-'),
    maskDemoField(isDemo, 'address-street', building.billingStreet || '-'),
    maskDemoField(isDemo, 'primary-contact', building.primary_contact || '-'),
    maskDemoField(isDemo, 'email', building.email_address || '-'),
    building.total_of_units || 0,
    building.student_housing,
    formatDispositioned(building.dispositioned),
    maskDemoField(isDemo, 'landlord-name', building.landlord_name || '-'),
    building.building_id,
  ];
}
